'use client';

import { defaultProps } from "../Select.defaultProps.js";
function parseProps({
  caption,
  dataQa,
  disabled,
  error,
  hiddenLabel,
  label,
  a11yLabel,
  required,
  options,
  onChange,
  value,
  placeholder,
  emptyLabel,
  isLoading,
  className,
  ...inputProps
}) {
  const selectFieldProps = {
    value,
    dataQa,
    onChange,
    options,
    noOptionsProvided: !options.length,
    placeholder,
    emptyLabel: emptyLabel ?? defaultProps.emptyLabel,
    isLoading
  };
  const formControlProps = {
    caption,
    disabled,
    error,
    label: {
      children: label
    },
    hiddenLabel,
    a11yLabel,
    required,
    className
  };
  return {
    selectFieldProps,
    formControlProps,
    inputProps
  };
}
export {
  parseProps
};
